import { render, staticRenderFns } from "./todo-geek.vue?vue&type=template&id=4b7bad83&scoped=true&"
import script from "./todo-geek.vue?vue&type=script&lang=js&"
export * from "./todo-geek.vue?vue&type=script&lang=js&"
import style0 from "./todo-geek.vue?vue&type=style&index=0&id=4b7bad83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7bad83",
  null
  
)

export default component.exports